import * as React from 'react';
import { withRouter } from 'react-router-dom';
import { Drawer, DrawerContent } from '@progress/kendo-react-layout';

import Header from './Header';

import Route from '../../Resources/Router.json';
import Screen from "../../Resources/Screen.json";

const items = [
    { selected: false, route: '/home', disabled: true, className: "pnxlogo" },
    { text: Screen.Layout.Title, route: `/${Route.MainPage}` }
];

class MainLayout extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            expanded: true,
            selectedId: items.findIndex(x => x.selected === true)
        };
    }

    onSelect = (e) => {
        this.setState({ selectedId: e.itemIndex });
        this.props.history.push(e.itemTarget.props.route);
    }

    setSelectedItem = (pathName) => {
        if (pathName === "/home") {
            return "";
        }

        let currentPath = items.find(item => item.route === pathName);
        if (currentPath && currentPath.text) {
            return currentPath.text;
        } else {
            return pathName;
        }
    }

    drawerProps = {
        position: 'start',
        mode: 'push',
        mini: true
    }

    render() {
        let selected = this.setSelectedItem(this.props.location.pathname);
        return (
            <Drawer style={{ height: "auto" }}
                expanded={this.state.expanded}
                items={items.map((item) => ({ ...item, selected: item.text === selected }))}
                {...this.drawerProps}
                onSelect={this.onSelect}
                className="pnxBodyContain">
                <DrawerContent>
                    <Header {...this.props} />
                    {this.props.children}
                </DrawerContent>
            </Drawer>
        );
    }
};

export default withRouter(MainLayout);
